// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__overlay___3AceM {
  --_apc-modal-overlay-background-color: var(--_apc-modal-overlay-background-color-lume, rgba(0, 0, 0, 0.76));

  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: var(--_apc-modal-overlay-background-color);
  opacity: 1;
  overflow-y: auto;
  z-index: 1040;
}

.DefaultTheme__modal___21WiE {
  --_apc-modal-border-radius: var(--_apc-modal-border-radius-lume, 4px);
  --_apc-modal-border: var(--_apc-modal-border-lume, none);
  --_apc-modal-box-shadow: var(--_apc-modal-box-shadow-lume, none);

  background: var(--tertiary);
  border: var(--_apc-modal-border);
  box-shadow: var(--_apc-modal-box-shadow);
  border-radius: var(--_apc-modal-border-radius);
  bottom: auto;
  color: var(--_apc-modal-color, var(--steel4));
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 140px);
  max-width: calc(100vw - 200px);
  min-width: 350px;
  outline: none;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: scale(1);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/Modal/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE,2GAA2G;;EAE3G,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,4DAA4D;EAC5D,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qEAAqE;EACrE,wDAAwD;EACxD,gEAAgE;;EAEhE,2BAA2B;EAC3B,gCAAgC;EAChC,wCAAwC;EACxC,8CAA8C;EAC9C,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,2BAA2B;AAC7B","sourcesContent":[".DefaultTheme__overlay___3AceM {\n  --_apc-modal-overlay-background-color: var(--_apc-modal-overlay-background-color-lume, rgba(0, 0, 0, 0.76));\n\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: var(--_apc-modal-overlay-background-color);\n  opacity: 1;\n  overflow-y: auto;\n  z-index: 1040;\n}\n\n.DefaultTheme__modal___21WiE {\n  --_apc-modal-border-radius: var(--_apc-modal-border-radius-lume, 4px);\n  --_apc-modal-border: var(--_apc-modal-border-lume, none);\n  --_apc-modal-box-shadow: var(--_apc-modal-box-shadow-lume, none);\n\n  background: var(--tertiary);\n  border: var(--_apc-modal-border);\n  box-shadow: var(--_apc-modal-box-shadow);\n  border-radius: var(--_apc-modal-border-radius);\n  bottom: auto;\n  color: var(--_apc-modal-color, var(--steel4));\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 140px);\n  max-width: calc(100vw - 200px);\n  min-width: 350px;\n  outline: none;\n  -webkit-overflow-scrolling: touch;\n  -webkit-transform: scale(1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
